import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import EmployeesMainContent from "./main";
import { Helmet } from "react-helmet-async";
import useUserStore from "../../../state-management/useUserStore";
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";
import { useMemo } from "react";

const Employees = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.EMPLOYEES_CREATE, PERMISSIONS.EMPLOYEES_WRITE, PERMISSIONS.EMPLOYEES_READ], 
		"OR"
	);
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])

	return (hasPermission && (
		<LAYOUT>
			<Helmet>
				{userType === "HR" ? (
					<title>Employee Management | HR Flow</title>
				):(
					<title>Employees | Company Flow</title>
				)}
			</Helmet>

			<EmployeesMainContent />
		</LAYOUT>
	));
};

export default Employees;
